import { Container, ContainerProps } from "@chakra-ui/react";
import Loading from "../components/Loading";

interface PageContainerProps extends ContainerProps {
  children: React.ReactNode;
  isLoading?: boolean;
}

function PageContainer({ children, isLoading = false }: PageContainerProps) {
  return (
    <Container my={10} maxW="container.lg">
      {isLoading && <Loading />}
      {children}
    </Container>
  );
}

export default PageContainer;
